// GroupBracket — vertical bracket SVG that visually contains a nested
// group's children (Screen 4 of the mockup). Pairs with a vertical
// ConnectorPill positioned on top of the bracket.
//
// The bracket is a single vertical line with a small horizontal serif at
// the top and bottom that points into the group. We draw it as an inline
// SVG so it scales with the group's height (parent must be a flex column
// so the bracket can fill the available height).

export type GroupBracketProps = {
  /** Color of the bracket line. Defaults to a light gray. */
  color?: string;
  className?: string;
};

export default function GroupBracket({
  color = '#d5d5d3',
  className = '',
}: GroupBracketProps) {
  return (
    <svg
      className={['h-full w-3 shrink-0', className].join(' ')}
      preserveAspectRatio="none"
      viewBox="0 0 12 100"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Vertical spine, full-height. */}
      <line x1="6" y1="0" x2="6" y2="100" stroke={color} strokeWidth="1" />
      {/* Top serif, points right into the group. */}
      <line x1="6" y1="0" x2="12" y2="0" stroke={color} strokeWidth="1" />
      {/* Bottom serif. */}
      <line x1="6" y1="100" x2="12" y2="100" stroke={color} strokeWidth="1" />
    </svg>
  );
}
